// extracted by mini-css-extract-plugin
export default {"container":"Section_container__RLe9J","header":"Section_header__XIeJu","body":"Section_body__F59UT"};